import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { option } from '../geolocationOption'

type GeoLocationState = {
  lat: number
  lon: number
  accuracy: number
  isLoaded: boolean
  /**
   * 位置情報を取得できたか（#3445）。
   * 取得失敗時の lat/lon は 0 のままなので、(0,0) を「未取得」の目印に使うと
   * 有効な座標と区別できない。判定にはこのフラグを使うこと。
   */
  available: boolean
}

const useGeoLocation = () => {
  const { t } = useTranslation()
  const [geoLocation, setGeoLocation] = useState<GeoLocationState>({
    lat: 0,
    lon: 0,
    accuracy: 0,
    isLoaded: false,
    available: false,
  })

  const setGeoLocationFn = (coords: GeolocationCoordinates) => {
    setGeoLocation({
      lat: coords.latitude,
      lon: coords.longitude,
      accuracy: coords.accuracy,
      isLoaded: true,
      available: true,
    })
  }

  useEffect(() => {
    getGeolocation(t('spot.access_error_message_02', '位置情報の使用許可がおりませんでした。'))
      .then((coords) => {
        if (coords) {
          setGeoLocationFn(coords)
        } else {
          // 取得失敗・拒否の場合も isLoaded = true にして、ローディングを終了させる
          setGeoLocation((prev) => ({ ...prev, isLoaded: true, available: false }))
        }
      })
      .catch(() => {
        // パーミッション拒否などの例外も isLoaded = true にする
        setGeoLocation((prev) => ({ ...prev, isLoaded: true, available: false }))
      })
  }, [])

  return geoLocation
}

export const getGeolocation = (message: string): Promise<GeolocationCoordinates | null> => {
  if ('geolocation' in navigator) {
    return new Promise<GeolocationCoordinates>((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        ({ coords }) => {
          resolve(coords)
        },
        reject,
        option,
      )
    })
  } else {
    alert(message)
    return Promise.resolve(null)
  }
}

export default useGeoLocation
